module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-item",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "product-content-section": "",
      "pa-0": "",
      "relative": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/album/' + _vm.album.slug
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "product-content",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-content-row",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-space-around": "",
      "column": "",
      "fill-height": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.album.user.display_name))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "product-content-row d-flex align-center justify-end gap-15",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.album.collaborators_count === 0) ? [(_vm.videoOnlyButtonAction) ? _c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Make Live Video Only")]) : _vm._e(), _vm._v(" "), (_vm.updateAccessLevelAction) ? _c('v-select', {
    staticClass: "pt-0 access-level",
    attrs: {
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "placeholder": "Select access level",
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "change": function($event) {
        _vm.toggle_album_access_level_dialog = true
      }
    },
    model: {
      value: (_vm.album.access_level),
      callback: function($$v) {
        _vm.$set(_vm.album, "access_level", $$v)
      },
      expression: "album.access_level"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editButtonAction) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.deleteButtonAction) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_album_delete_confirm_dialog = true
      }
    }
  }, [_vm._v("\n            Delete\n          ")]) : _vm._e()] : [_c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), (_vm.album.status == 'pending') ? _c('span', {
    staticClass: "collaboration-status"
  }, [(
    _vm.album.user.id === this.$store.state.auth.user.id &&
    _vm.usersCountByStatus.accepted === _vm.album.collaborators_count
  ) ? [_c('span', {
    staticClass: "approve-wrapper"
  }, [_c('v-btn', {
    staticClass: "text-btn release text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                  Release Now\n                ")])], 1)] : _c('span', {
    staticClass: "status-overview"
  }, [(_vm.usersCountByStatus.accepted > 0) ? _c('span', [_c('span', {
    staticClass: "accepted-title"
  }, [_vm._v("Accepted")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.denied > 0) ? _c('span', [_c('span', {
    staticClass: "denied-title"
  }, [_vm._v("Denied")]), _vm._v(" "), _vm._l((_vm.usersByStatus.denied), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.pending > 0) ? _c('span', [_c('span', {
    staticClass: "pending-title"
  }, [_vm._v("Waiting for approval")]), _vm._v(" "), _vm._l((_vm.usersByStatus.pending), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e()]), _vm._v(" "), (
    _vm.acceptButtonAction &&
    !_vm.usersByStatus.denied &&
    !_vm.usersByStatus.accepted
  ) ? _c('span', {
    staticClass: "collaboration-actions"
  }, [_c('v-btn', {
    staticClass: "text-btn deny text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                Deny\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn accept text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                Accept\n              ")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (
    _vm.editButtonAction &&
    this.$store.state.auth.user.id === _vm.album.user.id
  ) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (
    _vm.deleteButtonAction &&
    this.$store.state.auth.user.id === _vm.album.user.id
  ) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]], 2)], 1)], 1), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "collaborator-content-section": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "text-poppins-14"
  }, [_vm._v("\n        Collaborators (" + _vm._s(_vm.usersByStatus.accepted.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collaborator-content"
  }, [_vm._l((_vm.usersByStatus.accepted), function(c, i) {
    return _c('div', {
      key: i,
      staticClass: "collaborator-content__item"
    }, [_c('img', {
      staticClass: "collaborator-content__item--img",
      attrs: {
        "src": c.user.avatar.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "collaborator-content__item__user"
    }, [_c('span', {
      staticClass: "username"
    }, [_vm._v("\n              " + _vm._s(c.user.username) + "\n              "), (_vm.$store.state.auth.user.username === c.user.username) ? _c('span', [_vm._v("\n                (owner)\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "user-type"
    }, [_vm._v(_vm._s(c.user.user_type))])])])
  }), _vm._v(" "), (_vm.album.status == 'pending' && _vm.usersByStatus.denied > 0) ? _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "depressed": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_vm._v("\n          Release Now\n        ")]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.toggle_album_access_level_dialog),
      callback: function($$v) {
        _vm.toggle_album_access_level_dialog = $$v
      },
      expression: "toggle_album_access_level_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(" Update Access Level ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to update the access level?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAccessLevel()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Make an album available only for live\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will be available only for live video.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(" Delete Album ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, your followers won't see the album any more. Click OK\n        to delete <" + _vm._s(_vm.album.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63736202","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/components/albumList.vue
// module id = 1749
// module chunks = 180